module.exports = __webpack_public_path__ + "img/01_abe_10.23610172.jpg";